import { render } from "./AuthCodeVeification.vue?vue&type=template&id=1a7d2906"
import script from "./AuthCodeVeification.vue?vue&type=script&lang=js"
export * from "./AuthCodeVeification.vue?vue&type=script&lang=js"

import "./AuthCodeVeification.vue?vue&type=style&index=0&id=1a7d2906&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__